import { User } from "#models/User"
import * as S from "effect-app/Schema"
import * as Struct from "effect/Struct"
export class UserView extends S.Opaque<UserView>()(
  User.mapFields(Struct.omit(["password"])).annotate({ identifier: "UserView" })
) {}
